module.exports = __webpack_public_path__ + "img/title2-zh.a313f30c.png";